import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "/rumeli-logo.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img src={LOGO_URL} alt="Rumeli Üniversitesi" className="h-10 w-auto" />
            </div>
            <h3 className="font-heading text-lg font-bold uppercase tracking-wider mb-2">
              İRÜ Spor Kulübü
            </h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              İstanbul Rumeli Üniversitesi Bostancı Yerleşkesi bünyesinde faaliyet gösteren profesyonel spor kulübü.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-gold mb-6">
              Hızlı Erişim
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Hakkımızda", path: "/hakkimizda" },
                { label: "Branşlarımız", path: "/branslarimiz" },
                { label: "Yaz Spor Okulu", path: "/yaz-spor-okulu" },
                { label: "Tesisler", path: "/tesisler" },
                { label: "Ön Kayıt", path: "/on-kayit" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Branches */}
          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-gold mb-6">
              {`Branşlarımız`}
            </h4>
            <ul className="space-y-3">
              {[
                { name: "Voleybol", slug: "voleybol" },
                { name: "Basketbol", slug: "basketbol" },
                { name: "Cimnastik", slug: "cimnastik" },
              ].map((branch) => (
                <li key={branch.slug}>
                  <Link
                    to={`/branslarimiz/${branch.slug}`}
                    className="text-sm text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {branch.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-gold mb-6">
              İletişim
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-burgundy-300 mt-0.5 shrink-0" strokeWidth={1.5} />
                <span className="text-sm text-gray-400">
                  Bostancı, Tünel Girişi Sk. No:16, 34744 Kadıköy/İstanbul
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-burgundy-300 shrink-0" strokeWidth={1.5} />
                <a href="tel:05436470183" className="text-sm text-gray-400 hover:text-white transition-colors">
                  0543 647 01 83
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-burgundy-300 shrink-0" strokeWidth={1.5} />
                <a href="mailto:irusporkulubu@gmail.com" className="text-sm text-gray-400 hover:text-white transition-colors">
                  irusporkulubu@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">
            &copy; 2025 İRÜ Spor Kulübü. Tüm hakları saklıdır.
          </p>
          <p className="text-xs text-gray-500">
            İstanbul Rumeli Üniversitesi Bostancı Yerleşkesi
          </p>
        </div>
      </div>
    </footer>
  );
}
